import { Component, inject } from '@angular/core';
import { animations } from '../recent_queue/recent_queue.animation';
import { RecentQueueComponent } from '../recent_queue/recent_queue.component';
import { MainPageEndpointsService } from '../common/_services/main-page-endpoints.service';
import { RecentQueue, RecentQueueEndpointsService } from '../common/index';
import { CounterCustomizationRes } from '../common/_types/customizations.types';

@Component({
  selector: 'dynamic-queue-display',
  templateUrl: '../recent_queue/recent_queue.component.html',
  styleUrls: ['../recent_queue/recent_queue.component.scss'],
  providers: [RecentQueueEndpointsService],
  animations,
})
export class DynamicQueueDisplayComponent extends RecentQueueComponent {
  private mainPageEndpointsService = inject(MainPageEndpointsService);

  // Override the isRelevantQueue in order to react to all token events, regardless of the queueId
  protected isRelevantQueue() {
    return true;
  }

  loadRecentQueue() {
    this.mainPageEndpointsService.getCounterCustomization().subscribe({
      next: (customization) => {
        this.setDisplayData(customization);
        this.initPusherSubscription();
      },
      error: () => {
        this.setDisplayData();
        this.initPusherSubscription();
      },
    });
  }

  override initPusherSubscription() {
    if (this.recentQueueData) super.initPusherSubscription();
  }

  // TODO read view from customization when customization gets animation types
  private setDisplayData(customization?: CounterCustomizationRes) {
    this.recentQueueData = new RecentQueue(null);
    this.recentQueueData.setCustomization(customization);
    this.recentQueueData.logo = this.branchService.details?.logoOriginal;
    this.recentQueueData.view = 'rollup_animated';
    this.recentQueueData.fontColor ??= this.recentQueueData.DEFAULT_FONT_COLOR;
    this.recentQueueData.backgroundColor ??= this.recentQueueData.DEFAULT_BACKGROUND_COLOR;
    this.recentQueueData.fontFamily ??= this.recentQueueData.DEFAULT_FONT_FAMILY;
  }
}
